// ------------------------------------------ header
var class_array = [];

function toggle_class(selector, cls, container_cls){

    console.log(container_cls, class_array[class_array.length -1])

    if(class_array[class_array.length -1] == container_cls){
        $("."+selector).removeClass(cls);
        class_array = [];
    }
    else{
        $("."+selector).addClass(cls);
        class_array.push(container_cls);
    }

    $(".row-display").addClass("d-none");
    $("."+container_cls).removeClass("d-none");
}

function hamburger_menu(){
    $('.icon-hamburger').toggleClass('active'); 
    $('.mobile-nav-sidebar').toggleClass('active');
    $("body").toggleClass("overflow-hidden");
}

$(document).ready(function() {
    $("main[role='main']").click(function(){
        if($(".desktop-nav-sidebar").hasClass("active")){
            class_array = [];
            $(".desktop-nav-sidebar").removeClass("active");
        }
        else if($(".mobile-nav-sidebar").hasClass("active")){
            $(".mobile-nav-sidebar").removeClass("active");
            $("body").removeClass("overflow-hidden");
            $(".icon-hamburger").removeClass("active");
        }
    });
});
    
// ------------------------------------------ footer
$(document).ready(function() {
    $(window).on('resize', function(){
        var win = $(this);
        if(win.width <= 768){
            $(".footer-nav_sub-container:not(.index-1)").css("display", "none");
        }
    });
});

// ------------------------------------------ homepage

$(document).ready(function() {
    $("a").on('click', function(event) {
    if (this.hash !== "") {
        event.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 800, function(){
            window.location.hash = hash;
        });
        }
    });

    $(".featured-collection-carousel").slick({
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        variableWidth: true,
        useTransform: false,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 767,
                settings: {
                    dots: false,
                    nextArrow: '<svg class="nextarrow" xmlns="http://www.w3.org/2000/svg" width="13.503" height="23.619" viewBox="0 0 13.503 23.619"><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M20.683,18,11.746,9.07a1.688,1.688,0,0,1,2.391-2.384L24.262,16.8a1.685,1.685,0,0,1,.049,2.327L14.144,29.32a1.688,1.688,0,0,1-2.391-2.384Z" transform="translate(-11.251 -6.194)" fill="#f3f3f3"/></svg>',
                    prevArrow:'<svg class="prevarrow" xmlns="http://www.w3.org/2000/svg" width="13.503" height="23.619" viewBox="0 0 13.503 23.619"><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z" transform="translate(-11.251 -6.194)" fill="#f3f3f3"/></svg>',
                    infinite: false,
                    speed: 500,
                    cssEase: 'linear'
                }
            }
        ]
    });
});

// ------------------------------------------ homepage

$(document).ready(function() {
    // slider banner update
    var $banners = $('.banner-slider');
    if($banners.length > 0) {
      var $bannerSlider = $('.banner-slider').flickity({
        wrapAround: true,
        prevNextButtons: false,
        pageDots: true,
        dragThreshold: 10,
        autoPlay: 5000,
        pauseAutoPlayOnHover: true
      });
    }
    
    $(".read-more").click(function(){
        $(".bio-p").css("display", "block");
        $(".read-more").css("display", "none");
        $("#about-dvt-biography .read-less").css("display", "block");
    });

    $('#about-dvt-biography .read-less').click(function(){
         $("#about-dvt-biography .bio-p:gt(1)").css("display", "none");
         $("#about-dvt-biography .read-more").css("display", "block");
         $(this).hide();
         $('html, body').animate({ scrollTop: $('#about-dvt-biography').offset().top }, 'fast');
    })

    $("#about-dvt-video .play").click(function(){
        if($(this).hasClass("pause")){
            $("#about-dvt-video .icon-pause").css("display", "none");
            $("#about-dvt-video .icon-play").css("display", "block");
            $("video").get(0).pause();
            $(this).removeClass("pause");
            $(this).addClass("playing");
        }
        else{
            $("#about-dvt-video .icon-play").css("display", "none");
            $("#about-dvt-video .icon-pause").css("display", "block");
            $("video").get(0).play();
            $(this).removeClass("playing");
            $(this).addClass("pause");
        }
    });
});

// ------------------------------------------ about

$(document).ready(function(){
    $("#about-dvt-carousel").slick({
        dots: true,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        variableWidth: true,
        useTransform: false,
        swipeToSlide: true,
    });
})

// ------------------------------------------ collection list items

$(document).ready(function() {

   $('.new-slides').slick({
     slidesToShow: 4,
     slidesToScroll: 1,
     speed: 500,
     swipeToSlide: true,
     cssEase: 'linear',
     useTransform: false,
     arrows:true,
      nextArrow: '<svg class="nextarrow" xmlns="http://www.w3.org/2000/svg" width="13.503" height="23.619" viewBox="0 0 13.503 23.619"><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M20.683,18,11.746,9.07a1.688,1.688,0,0,1,2.391-2.384L24.262,16.8a1.685,1.685,0,0,1,.049,2.327L14.144,29.32a1.688,1.688,0,0,1-2.391-2.384Z" transform="translate(-11.251 -6.194)" fill="#f3f3f3"/></svg>',
      prevArrow:'<svg class="prevarrow" xmlns="http://www.w3.org/2000/svg" width="13.503" height="23.619" viewBox="0 0 13.503 23.619"><path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z" transform="translate(-11.251 -6.194)" fill="#f3f3f3"/></svg>',
      infinite: true,
      responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                         infinite: false,
                    }
                }
            ]
  })

    $(".carousel-list-collections").each(function(index){
        $(".carousel-list-collections."+index).slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true
                    }
                }
            ]
        });
    });

});

//VoN follies
setTimeout(() => {
   if (window.location.href === "https://uk.ditavonteeselingerie.com/") {
   
    var mainElement = document.querySelector('main[role="main"]'); 
      
    // Get the data-bg-color attribute from the span element 
    var bgColor = document.querySelector('span[data-bg-color]').getAttribute('data-bg-color');
    
    // Apply the background color to the main element
       mainElement.classList.add(bgColor); 
      
  
    var indextrustbadges = document.getElementById('index-trust-badges');
    if (indextrustbadges) {
      indextrustbadges.style.background = 'none';
    }
      var indexaboutdvt = document.getElementById('index-about-dvt');
    if (indexaboutdvt) {
      indexaboutdvt.style.background = 'none';
    }
       var indexjoinourfamilyform = document.getElementById('index-join-our-family-form'); 
    if (indexjoinourfamilyform) {
      indexjoinourfamilyform.style.background = 'none';
    }
    // Loop through each element and remove the background style
    var indexCollectionsElements = document.querySelectorAll('#index-collections'); 
    indexCollectionsElements.forEach(function(element) {
      element.style.background = 'none'; // Set the background to "none"
    });
   
      setTimeout(() => { 
        var email= document.getElementById("email_74796117")
        var ele = document.querySelector("#index-join-our-family-form > div > div > div > div.klaviyo-form-Yc4f33.klaviyo-form.form-version-cid-1 > div > form")
        var t = document.querySelector("#index-join-our-family-form > div > div > div > div.klaviyo-form-Yc4f33.klaviyo-form.form-version-cid-1 > div > form > div > div:nth-child(3) > div")
        if(ele && email)
        { 
           t.style.background= '#63003E';
          ele.style.background = '#63003E';
          ele.style.border = 'none';
          email.style.background = 'none';
        }
      }, 4000)
      
      
  }
  var myId = document.getElementById('custom-video-player');
  if(myId)
  {
    var player = new Vimeo.Player(myId);
  // Set the default volume to muted (0)
    if(player) {
      player.setVolume(0);
    }
  }
}, 1000);

 // video


function myFunction() {
  var player = new Vimeo.Player(document.getElementById('custom-video-player'));
var muteUnmuteButton = document.getElementById('mute-unmute-button');
  //player.setVolume(0);
player.getVolume().then(function(volume) {
    if (volume === 0) {
        player.setVolume(1);
        muteUnmuteButton.textContent = 'Mute';
        muteUnmuteButton.classList.add('mute');
        muteUnmuteButton.classList.remove('unmute');
    } else {
        player.setVolume(0);
        muteUnmuteButton.textContent = 'Unmute';
        muteUnmuteButton.classList.add('unmute');
        muteUnmuteButton.classList.remove('mute');
    }
});

}

